var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"search-results-summary"},[_c('div',{staticClass:"search-results-res"},[_vm._v(_vm._s(_vm.getSummary)+" "+_vm._s(" " + _vm.$t('results') + " ")+" "+_vm._s(this.getSearchResultsField('summary') ? _vm.$t('for') + _vm.getSummaryText : ''))])]),_c('SearchResultsHeader'),_c('SearchResultsBody')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }